import { NgModule } from '@angular/core';
import { AuthGuard } from '@angular/fire/auth-guard';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/startup',
    pathMatch: 'full'
  },
  // ,
  // {
  //   path: 'walkthrough',
  //   loadChildren: () => import('./walkthrough/walkthrough.module').then(m => m.WalkthroughPageModule)
  // },
  // {
  //   path: 'getting-started',
  //   loadChildren: () => import('./getting-started/getting-started.module').then(m => m.GettingStartedPageModule)
  // },
  {
    path: 'auth',
    redirectTo: 'auth/login',
    pathMatch: 'full'
  },
  {
    path: 'auth/login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'startup',
    loadChildren: () => import('./nenomed-main/startup/startup.module').then(m => m.StartupPageModule)
  },
  {
    path: 'app/customers',
    loadChildren: () => import('./nenomed-main/customers/customers.module').then(m => m.CustomersPageModule)
  },
  {
    path: 'auth/signup',
    loadChildren: () => import('./signup/signup.module').then(m => m.SignupPageModule)
  },
  {
    path: 'auth/forgot-password',
    loadChildren: () => import('./forgot-password/forgot-password.module').then(m => m.ForgotPasswordPageModule)
  },
  {
    path: 'app',
    loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule)
  },
  {
    path: 'app/patient-detail',
    loadChildren: () => import('./nenomed-main/patient-detail/patient-detail.module').then(m => m.PatientDetailPageModule)
  },
  {
    path: 'app/patient-detail/:dni',
    loadChildren: () => import('./nenomed-main/patient-detail/patient-detail.module').then(m => m.PatientDetailPageModule)
  },
  {
    path: 'app/folder/:folderId',
    loadChildren: () => import('./nenomed-main/explorer/folder/folder.module').then(m => m.FolderPageModule)
    
  },
  {
    path: 'app/card/:contentId',
    loadChildren: () => import('./nenomed-main/card/card.module').then(m => m.CardPageModule)
    
  },
  {
    path: 'contact-card',
    loadChildren: () => import('./contact-card/contact-card.module').then(m => m.ContactCardPageModule)
  },
  {
    path: 'forms-and-validations',
    loadChildren: () => import('./forms/validations/forms-validations.module').then(m => m.FormsValidationsPageModule)
  },
  {
    path: 'forms-filters',
    loadChildren: () => import('./forms/filters/forms-filters.module').then(m => m.FormsFiltersPageModule)
  },
  {
    path: 'page-not-found',
    loadChildren: () => import('./page-not-found/page-not-found.module').then(m => m.PageNotFoundModule)
  },
  {
    path: 'showcase',
    loadChildren: () => import('./showcase/showcase.module').then(m => m.ShowcasePageModule)
  },
  {
    path: 'firebase',
    redirectTo: 'firebase/auth/sign-in',
    pathMatch: 'full'
  },
  {
    path: 'firebase/auth',
    loadChildren: () => import('./firebase/auth/firebase-auth.module').then(m => m.FirebaseAuthModule)
  },
  {
    path: 'firebase/crud',
    loadChildren: () => import('./firebase/crud/firebase-crud.module').then(m => m.FirebaseCrudModule)
  },
  {
    path: 'maps',
    loadChildren: () => import('./maps/maps.module').then(m => m.MapsPageModule)
  },
  {
    path: 'video-playlist',
    loadChildren: () => import('./video-playlist/video-playlist.module').then(m => m.VideoPlaylistPageModule)
  },
  {
    path: 'profile',
    loadChildren: () => import('./user/profile/user-profile.module').then(m => m.UserProfilePageModule)
  },
  {
    path: '**',
    redirectTo: 'page-not-found'
  }
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      // This value is required for server-side rendering to work.
      initialNavigation: 'enabledBlocking',
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
